import { decrypt } from "../services/security/encryptorHandlerSecurity";

const validateLocal = () => {
  if (Object.keys(localStorage).length >= 6 ){
    for (let key of Object.keys(localStorage)) {
      if(decrypt(key).includes('-Validate-')){
        if(localStorage.getItem(JSON.parse(decrypt(localStorage.getItem(key))).valid))
        return JSON.parse(decrypt(localStorage.getItem(key))).valid;
      }
    }
  }
  return null;
}

export default { validateLocal }